// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__4CsBv","colMaxWidth":"Table_colMaxWidth__2pMMB"};